module.exports = __webpack_public_path__ + "static/banner03-598537e3d75e16eb426ea9a0d683f7a3.png";